import { get as getProjection } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import React, { useMemo } from 'react';
import useApplicationState from '../hooks/useApplicationState';
import useDefaultsCache from '../hooks/useDefaultsCache';
import { View as ReactOlView } from '../react-ol/components/View';

var registerProjection = projectionToRegister => {
  var projection = null;

  if (projectionToRegister) {
    var _projection;

    proj4.defs(projectionToRegister.epsgName, projectionToRegister.projectionString);
    register(proj4);
    projection = getProjection(projectionToRegister.epsgName);
    (_projection = projection) === null || _projection === void 0 ? void 0 : _projection.setExtent(projectionToRegister.extent);
  }

  return projection;
}; // minZoom and maxZoom values used for zoom constraint


export var View = _ref => {
  var _cachedDefaults$bBoxE;

  var {
    maxZoom,
    minZoom
  } = _ref;
  var {
    cachedDefaults
  } = useDefaultsCache();
  var {
    overrides
  } = useApplicationState();
  var projection = useMemo(() => registerProjection(cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection), [cachedDefaults]);

  if (!cachedDefaults || !projection) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  return /*#__PURE__*/React.createElement(ReactOlView, {
    resolutions: cachedDefaults.resolutions,
    projection: projection,
    center: (overrides === null || overrides === void 0 ? void 0 : overrides.defaultCenter) || [cachedDefaults.defaultPositionX, cachedDefaults.defaultPositionY],
    zoom: (overrides === null || overrides === void 0 ? void 0 : overrides.defaultZoom) || cachedDefaults.defaultScale.openLayersLevel,
    extent: (_cachedDefaults$bBoxE = cachedDefaults.bBoxExtent) !== null && _cachedDefaults$bBoxE !== void 0 ? _cachedDefaults$bBoxE : overrides === null || overrides === void 0 ? void 0 : overrides.bBoxExtent,
    maxZoom: maxZoom,
    minZoom: minZoom
  });
};